export default "__VITE_ASSET__DWFIRlFb__"